import React from "react";

export default function HouseIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="31"
      height="31"
      viewBox="0 0 31 31"
      fill="none"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M27.8653 9.0516L20.0106 2.55728C17.3648 0.369742 13.6352 0.369739 10.9894 2.55728L3.13475 9.0516C1.71961 10.2216 0.916672 11.9957 0.916672 13.8466V25.5244C0.916672 27.9569 2.79272 30.0833 5.29167 30.0833H8.20834C10.6246 30.0833 12.5833 28.1245 12.5833 25.7083V20.8736C12.5833 19.8814 13.319 19.2314 14.0417 19.2314H16.9583C17.681 19.2314 18.4167 19.8814 18.4167 20.8736V25.7083C18.4167 28.1245 20.3754 30.0833 22.7917 30.0833H25.7083C28.2073 30.0833 30.0833 27.9569 30.0833 25.5244V13.8466C30.0833 11.9957 29.2804 10.2216 27.8653 9.0516Z"
        fill="#45486E"
      />
    </svg>
  );
}
